/**
 * Format part specification for display: users type "+-" (ASCII) but we show "±".
 * Does not alter unrelated text; only replaces a plus sign followed by a minus sign
 * (with optional surrounding whitespace) with the Unicode plus-minus sign.
 *
 * @param {string|null|undefined} s
 * @returns {string}
 */
export function formatSpecificationDisplay(s) {
  if (s == null || s === '') return '';
  return String(s).replace(/\s*\+\s*-\s*/g, ' ± ');
}
